import { PhoneSolid, StarSolid } from '@allocab/allocab-icons';
import { TripDriverOutput } from '@allocab/allocab-passenger-shared-types';
import clsx from 'clsx';

import { t } from '../../services/translation/translation';
import { TripStep } from '../../utils/trip';

type Props = {
  step: TripStep;
  driver: TripDriverOutput;
  className?: string;
};

export const TripDriver = ({ driver, step, className }: Props) => {
  return (
    <div className={clsx('flex-col flex w-full', className)}>
      {step === 'ONDUTY' ? (
        <div
          className="flex items-center justify-between w-full text-center"
          dangerouslySetInnerHTML={{
            __html: t('share-route.trip-detail.driver-onduty', { name: driver.firstName }),
          }}
        />
      ) : (
        <div className="flex flex-col gap-y-2">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-start flex-col">
              <strong className="capitalize">
                {driver.vehicle.brand} {driver.vehicle.range}
              </strong>
              <span className="capitalize">{driver.vehicle.color}</span>
            </div>
            <span className="ml-1 px-2 bg-primary bg-opacity-20 border-x-4 border-primary">
              {driver.vehicle.licensePlate}
            </span>
          </div>
          <hr />
          <div className="flex items-center justify-between w-full">
            <div className="flex items-start flex-col w-full">
              <strong className="flex items-center">{driver.firstName}</strong>
              {driver.note ? (
                <span className="flex items-center">
                  <StarSolid className="fill-primary" width={16} height={16} />
                  {driver.note.toFixed(1)}
                </span>
              ) : null}
            </div>

            <a
              href={`tel:${driver.phoneNumber}`}
              className="flex items-center justify-center bg-cta rounded-full h-12 w-12 sm:hidden"
            >
              <PhoneSolid width={24} height={24} className="fill-text_light" />
            </a>
            <div className="items-center gap-1 hidden sm:flex">
              <PhoneSolid width={12} height={12} className="fill-current" />
              <p>{driver.phoneNumber}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
